import { createAsyncThunk } from '@reduxjs/toolkit'
import { CustomFieldsGroup, CustomFieldsAttributes, CustomFieldsServerData, CustEEItemParams } from '@lk/api'
import { ThunkApi } from '../index.d'
import { getCustomFieldsByCacheKey } from './customFields.selectors'

export type LoadCustomFieldsAttributes = CustomFieldsAttributes & {
  groupId: CustomFieldsGroup
  cacheKey?: string
}

export interface LoadCustomFieldsPayload {
  cacheKey: string
  data: CustomFieldsServerData
}

export const loadCustomFields = createAsyncThunk<LoadCustomFieldsPayload, LoadCustomFieldsAttributes, ThunkApi>(
  '[CUSTOM_FIELDS] LOAD_CUSTOM_FIELDS',
  async ({ cacheKey, ...attributes }, { extra, rejectWithValue }) => {
    const result = await extra.api.customFields.get(attributes.groupId, attributes)

    if (result.success) {
      return {
        cacheKey,
        data: result.data,
      }
    }

    return rejectWithValue('Failed to load custom fields')
  },
)

export const custEEItemFind = createAsyncThunk<any, CustEEItemParams, ThunkApi>(
  '[CUSTOM_FIELDS/EE-ITEMS] FIND_CUSTOM_EE_ITEMS',
  async ({ ...params }, { extra, rejectWithValue }) => {
    const result = await extra.api.customFields.custEEItems('find', params)
    if (result.success) {
      return result.data
    }

    return rejectWithValue(result.error.message)
  },
)

export const custEEItemNew = createAsyncThunk<any, CustEEItemParams, ThunkApi>(
  '[CUSTOM_FIELDS/EE-ITEMS] NEW_CUSTOM_EE_ITEM',
  async ({ ...params }, { extra, rejectWithValue }) => {
    const result = await extra.api.customFields.custEEItems('new', params)

    if (result.success) {
      return result.data
    }

    return rejectWithValue(result.error.message)
  },
)

export const loadCustomFieldsIfNeeded = (attributes: LoadCustomFieldsAttributes) => {
  return (dispatch, getState) => {
    const cachedValue = getCustomFieldsByCacheKey(getState(), attributes.cacheKey)

    if (!cachedValue) {
      dispatch(loadCustomFields(attributes))
    }
  }
}
